import classNames from 'classnames'

export function DialogTopSectionWithIcon({
  ColoredIcon,
  title,
  description,
  className,
  titleClassName,
  titleId,
  titleTestId,
}: {
  ColoredIcon?: React.ReactNode
  title: string
  description?: string | React.ReactNode
  className?: string
  titleClassName?: string
  titleId?: string
  titleTestId?: string
}) {
  return (
    <div className={classNames('mb-6 flex flex-col items-center', className)}>
      {ColoredIcon && (
        <div className="mb-4 flex flex-row justify-center">{ColoredIcon}</div>
      )}
      <h1
        id={titleId}
        data-testid={titleTestId}
        className={classNames(
          'mb-2 text-center text-headline-large',
          titleClassName
        )}
      >
        {title}
      </h1>
      {typeof description === 'string' ? (
        <div className="max-w-[500px] text-center text-body-large whitespace-pre-line">
          {description}
        </div>
      ) : (
        <div className="max-w-[500px]">{description}</div>
      )}
    </div>
  )
}
